import { JSONSchema7 } from 'json-schema';
import { MouseEvent, useContext, useMemo } from 'react';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext,
  WorkflowEngineMode
} from '../../WorkflowEngine/workflowEngineReducer';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import PageState from '../../Shared/pageState';
import Step from '@mui/material/Step';
import Stack from '@mui/material/Stack';
import { SxProps, Theme } from '@mui/material/styles';
import { PagePermissionLevel } from '../../Shared/Enums/pagePermissionLevel';
import getPagePermissionForRole from '../../Shared/jsonSchemaUtilities/getPagePermissionForRole';
import { Stepper, StepLabel } from '@mui/material';
import { SideStepLabel } from '@abbott-components/core';

export default ({ sx }: { sx?: SxProps<Theme> }) => {
  const { state, dispatch } = useContext(WorkflowEngineContext);
  const { pages, currentPage, role, mode } = state;

  const renderStep = (page: PageState, index: number) => {
    const pageSchema = (page.schema.properties as JSONSchema7Properties)[
      'page'
    ] as JSONSchema7;

    const hasAccess =
      mode == WorkflowEngineMode.ENTRY || mode == WorkflowEngineMode.PREVIEW
        ? getPagePermissionForRole(pageSchema, role) !==
          PagePermissionLevel.NoAccess
        : true;

    const handleStepClick = (e: MouseEvent<HTMLElement>) => {
      const isStepDisabled = e.currentTarget.querySelector('.Mui-disabled');

      if (!hasAccess || isStepDisabled) return;

      dispatch({
        type: WorkflowEngineActionKind.SET_CURRENT_PAGE,
        payload: index
      });
    };

    return role === 'Donor' ? (
      hasAccess ? (
        <Step key={page.id}>
          <Stack
            onClick={handleStepClick}
            sx={{
              cursor: hasAccess ? 'pointer' : 'default',
              padding: '12px'
            }}
          >
            <SideStepLabel label="" />
          </Stack>
        </Step>
      ) : null
    ) : (
      <Step key={page.id}>
        <Stack
          onClick={handleStepClick}
          sx={{
            cursor: hasAccess ? 'pointer' : 'default',
            padding: '12px'
          }}
        >
          <SideStepLabel label="" />
        </Stack>
      </Step>
    );
  };

  return useMemo(
    () =>
      pages.length ? (
        <Stack
          sx={{
            '.MuiBox-root': {
              maxWidth: '100%'
            },
            '.MuiStepper-root': {
              overflowX: 'scroll'
            },
            ...sx
          }}
        >
          <Stepper activeStep={currentPage}>
            {pages.map((page: PageState, index: number) =>
              renderStep(page, index)
            )}
          </Stepper>
        </Stack>
      ) : null,
    [pages, currentPage, role]
  );
};
